
<div class="myChart">
  <canvas id="myChart2"></canvas>
</div>
